import { EFeatureCategory } from "../types/EFeatureCategory"

export const FeatureCategories: EFeatureCategory[] = [
    EFeatureCategory.Automations,
    EFeatureCategory.EmailMarketing,
    EFeatureCategory.Audience,
    EFeatureCategory.LandingPages,
    EFeatureCategory.PopUps,
    EFeatureCategory.API,
    EFeatureCategory.Reporting,
    EFeatureCategory.Support,
]